import React from "react";
import { FormLabel } from "@chakra-ui/form-control";
import styled from "styled-components";

interface Props {
  htmlFor?: string;
  fontWeight?: string;
}

export const Label: React.FC<Props> = ({ htmlFor, fontWeight, ...props }) => {
  return (
    <StyledFormLabel htmlFor={htmlFor} fontWeight={fontWeight}>
      {props.children}
    </StyledFormLabel>
  );
};

const StyledFormLabel = styled(FormLabel)`
  color: ${(props) => props.theme.colors.secondaryText1};

  font-family: Helvetica Neue;
  font-style: normal;
  font-weight: ${(props) =>
    props.fontWeight ? props.fontWeight : "normal !important"};
  font-size: 0.75rem !important;
  line-height: 12px;
`;
